var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "withdrawal_management" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "上架商品", name: "first" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "下架商品", name: "second" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "search_criteria",
          staticStyle: { "margin-top": "10px" },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-left": "0" } },
            [
              _c("el-input", {
                attrs: { placeholder: "输入商品名称查询", clearable: "" },
                model: {
                  value: _vm.queryData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "title", $$v)
                  },
                  expression: "queryData.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "选择所属活动",
                  },
                  model: {
                    value: _vm.queryData.activityId,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryData, "activityId", $$v)
                    },
                    expression: "queryData.activityId",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.activityName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex",
              staticStyle: { width: "fit-content", height: "40px" },
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { height: "40px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.onInquire },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "ml10",
                  staticStyle: { height: "40px" },
                  attrs: { type: "info", plain: "" },
                  on: { click: _vm.onInitialize },
                },
                [_vm._v("重置")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.onAdd },
                },
                [_vm._v("新增+")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", plain: "" },
                  on: { click: _vm.onSynchronization },
                },
                [_vm._v("同步商品信息")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticClass: "mt20" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  data: _vm.tableData,
                  "tooltip-effect": "dark",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", label: "排序", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "activityName",
                    label: "所属活动",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "goodsId", label: "商品ID", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "商品信息", align: "center", width: "500" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "flex mt10",
                              staticStyle: {
                                border: "1px solid #dcdfe6",
                                width: "fit-content",
                                "border-radius": "10px",
                                padding: "10px",
                                "line-height": "20px",
                              },
                            },
                            [
                              _c("div", { staticClass: "fc" }, [
                                _c("img", {
                                  staticStyle: {
                                    width: "40px",
                                    height: "40px",
                                  },
                                  attrs: {
                                    src: scope.row.goodsDetailVo.picUrl,
                                    alt: "",
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml10" }, [
                                _c(
                                  "div",
                                  { staticClass: "ellipsis-multiline" },
                                  [
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            scope.row.goodsDetailVo
                                              .platformCode === "JD",
                                          expression:
                                            "scope.row.goodsDetailVo.platformCode === 'JD'",
                                        },
                                      ],
                                      staticClass: "icon_img",
                                      attrs: {
                                        alt: "",
                                        src: require("@/assets/platformIcon/jd.png"),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            scope.row.goodsDetailVo
                                              .platformCode === "PDD",
                                          expression:
                                            "scope.row.goodsDetailVo.platformCode === 'PDD'",
                                        },
                                      ],
                                      staticClass: "icon_img",
                                      attrs: {
                                        alt: "",
                                        src: require("@/assets/platformIcon/pdd.png"),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            scope.row.goodsDetailVo
                                              .platformCode === "WPH",
                                          expression:
                                            "scope.row.goodsDetailVo.platformCode === 'WPH'",
                                        },
                                      ],
                                      staticClass: "icon_img",
                                      attrs: {
                                        alt: "",
                                        src: require("@/assets/platformIcon/wph.png"),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            scope.row.goodsDetailVo
                                              .platformCode === "TB",
                                          expression:
                                            "scope.row.goodsDetailVo.platformCode === 'TB'",
                                        },
                                      ],
                                      staticClass: "icon_img",
                                      attrs: {
                                        alt: "",
                                        src: require("@/assets/platformIcon/tb.png"),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            scope.row.goodsDetailVo
                                              .platformCode === "DY",
                                          expression:
                                            "scope.row.goodsDetailVo.platformCode === 'DY'",
                                        },
                                      ],
                                      staticClass: "icon_img",
                                      attrs: {
                                        alt: "",
                                        src: require("@/assets/platformIcon/dy.png"),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            scope.row.goodsDetailVo
                                              .platformCode === "KS",
                                          expression:
                                            "scope.row.goodsDetailVo.platformCode === 'KS'",
                                        },
                                      ],
                                      staticClass: "icon_img",
                                      attrs: {
                                        alt: "",
                                        src: require("@/assets/platformIcon/ks.png"),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            scope.row.goodsDetailVo
                                              .platformCode === "ELM",
                                          expression:
                                            "scope.row.goodsDetailVo.platformCode === 'ELM'",
                                        },
                                      ],
                                      staticClass: "icon_img",
                                      attrs: {
                                        alt: "",
                                        src: require("@/assets/platformIcon/elm.png"),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            scope.row.goodsDetailVo
                                              .platformCode === "MT",
                                          expression:
                                            "scope.row.goodsDetailVo.platformCode === 'MT'",
                                        },
                                      ],
                                      staticClass: "icon_img",
                                      attrs: {
                                        alt: "",
                                        src: require("@/assets/platformIcon/mt.png"),
                                      },
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(scope.row.goodsDetailVo.title) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", [
                                    _vm._v("\n                    原价:"),
                                    _c(
                                      "span",
                                      { staticClass: "original-price" },
                                      [
                                        _vm._v(
                                          "￥" +
                                            _vm._s(
                                              scope.row.goodsDetailVo.orgPrice
                                            )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "ml20" }, [
                                    _vm._v("\n                    券额:"),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          "￥" +
                                            _vm._s(
                                              scope.row.goodsDetailVo
                                                .couponAmount
                                            )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "ml20" }, [
                                    _vm._v("\n                    券后价:"),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          "￥" +
                                            _vm._s(
                                              scope.row.goodsDetailVo
                                                .actualPrice
                                            )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "subsidyAmt",
                    label: "礼金金额",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "orderNum",
                    label: "已售商品数",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "subsidyStartTime",
                    label: "开始时间",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "subsidyEndTime",
                    label: "结束时间",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _vm.queryData.status === 0
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "remark",
                        label: "下架原因",
                        align: "center",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "remark",
                    label: "操作",
                    align: "center",
                    width: "300",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "fc" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEditor(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDel(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                              _vm._v(" "),
                              scope.row.pinned === 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onUnTop(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("取消置顶")]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.oNPinned(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("置顶")]
                                  ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt20 page_box" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryData.page.page,
                "page-sizes": [10, 20, 30, 40],
                "page-size": _vm.queryData.page.size,
                layout: "total, prev, pager, next, sizes,jumper",
                total: _vm.total,
                background: "",
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "商品" + (_vm.eventsType === "add" ? "添加" : "编辑"),
            visible: _vm.dialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c("div", { staticClass: "fc" }, [
            _c("div", { staticStyle: { width: "800px" } }, [
              _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品类型", prop: "platformCode" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.ruleForm.platformCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "platformCode", $$v)
                                },
                                expression: "ruleForm.platformCode",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { value: "TB", label: "TB" } },
                                [_vm._v("淘宝")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                { attrs: { label: "JD", disabled: "" } },
                                [_vm._v("京东")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                { attrs: { label: "PDD", disabled: "" } },
                                [_vm._v("拼多多")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                { attrs: { label: "DY", disabled: "" } },
                                [_vm._v("抖音")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品ID", prop: "goodsId" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.ruleForm.goodsId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "goodsId", $$v)
                                  },
                                  expression: "ruleForm.goodsId",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ml10",
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-search",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onShare(
                                        _vm.ruleForm.platformCode,
                                        _vm.ruleForm.goodsId
                                      )
                                    },
                                  },
                                },
                                [_vm._v("搜索")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.ProductDetails.id
                            ? _c(
                                "div",
                                {
                                  staticClass: "flex mt10",
                                  staticStyle: {
                                    border: "1px solid #dcdfe6",
                                    width: "fit-content",
                                    "border-radius": "10px",
                                    padding: "10px",
                                    "line-height": "20px",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "fc" }, [
                                    _c("img", {
                                      staticStyle: {
                                        width: "40px",
                                        height: "40px",
                                      },
                                      attrs: {
                                        src: _vm.ProductDetails.picUrl,
                                        alt: "",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "ml10" }, [
                                    _c(
                                      "div",
                                      { staticClass: "ellipsis-multiline" },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.ProductDetails.title) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "flex" }, [
                                      _c("div", [
                                        _vm._v("\n                      原价:"),
                                        _c(
                                          "span",
                                          { staticClass: "original-price" },
                                          [
                                            _vm._v(
                                              "￥" +
                                                _vm._s(
                                                  _vm.ProductDetails.orgPrice
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "ml20" }, [
                                        _vm._v("\n                      券额:"),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              "￥" +
                                                _vm._s(
                                                  _vm.ProductDetails
                                                    .couponAmount
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "ml20" }, [
                                        _vm._v(
                                          "\n                      券后价:"
                                        ),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              "￥" +
                                                _vm._s(
                                                  _vm.ProductDetails.actualPrice
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticStyle: { color: "#e6a23c" } }, [
                            _vm._v(
                              "\n                注：确认商品，点击保存后，商品ID可能会替换为平台专属商品ID，ID样式可能会发生变化\n              "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "所属活动", prop: "activityId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "选择所属活动",
                              },
                              model: {
                                value: _vm.ruleForm.activityId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "activityId", $$v)
                                },
                                expression: "ruleForm.activityId",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.activityName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "礼金金额", prop: "subsidyAmt" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.ruleForm.subsidyAmt,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "subsidyAmt", $$v)
                              },
                              expression: "ruleForm.subsidyAmt",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "注:设定补贴金额时，务必参考价格最低的 SKU 款式价格。"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品上架时间", prop: "timeArray" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "default-time": ["00:00:00", "23:59:59"],
                            },
                            model: {
                              value: _vm.ruleForm.timeArray,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "timeArray", $$v)
                              },
                              expression: "ruleForm.timeArray",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品状态", prop: "goodsStatus" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.ruleForm.goodsStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "goodsStatus", $$v)
                                },
                                expression: "ruleForm.goodsStatus",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("上架"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("下架"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("确认")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }